/* src/app/private/components/registration/move-to-application/move-to-application.component.scss */
/*# sourceMappingURL=move-to-application.component.css.map */
